import { PointType } from '@shared/types/geoTypes'

export type AddressModelJson = {
  latitude: number | null
  longitude: number | null
  city: string | null
  country: string
  addressEn: string | null
  userCount: number
}

export class AddressModel {
  constructor(
    public latitude: number | null,
    public longitude: number | null,
    public city: string | null,
    public country: string,
    public addressEn: string | null = '',
    public userCount: number = 0
  ) {}

  public getLatitude(): number | null {
    return this.latitude
  }
  public getLongitude(): number | null {
    return this.longitude
  }
  public getCoordinatesPair(): PointType {
    return {
      lat: this.latitude ?? 0,
      long: this.longitude ?? 0
    }
  }
  public getCity(): string | null {
    return this.city
  }
  public getAddress(): string {
    return this.addressEn ?? ''
  }
  public getUserCount(): number {
    return this.userCount
  }
  public getCountry(): string {
    return this.country
  }
  public getJson(): AddressModelJson {
    return {
      latitude: this.latitude,
      longitude: this.longitude,
      city: this.city,
      country: this.country,
      addressEn: this.addressEn,
      userCount: this.userCount
    }
  }
}
